<template>
  <no-auth v-if="!hasAuthorize.list"></no-auth>
  <div :class="{ 'o-card': !tab }" v-else>
    <Table
      no-card
      :title="$t(`${name}.mainTitle`)"
      :description="$t(`${name}.description`)"
      i18n
      :loading="loading"
      :status="$status.series"
      :items="items"
      checkable
      :checkValue="checkedList"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="count"
      :pages="pages"
      :searchValue="search"
      @change:search="setSearch"
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : items"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>
          <router-link :to="{ name: `vinc-calculating` }">
            <Button v-if="hasAuthorize.add" variant="light-primary">
              + {{ $t(`${name}.add`) }}
            </Button>
          </router-link>
        </div>
      </template>
      <template #potDimensions="{ item }">
        <div class="u-cursor-pointer">
          <router-link
            :to="{
              name: `vinc-calculating-detail`,
              params: { id: item.id },
            }"
          >
            <div class="u-color-primary"># {{ item.title }}</div>
            <span>
              {{ $t("vincCalculating.potDiameter") }} :
              {{ item.requestPotDiameter }}
            </span>
            <span>
              {{ $t("vincCalculating.potHeight") }} :
              {{ item.requestPotHeight }}
            </span>
          </router-link>
        </div>
      </template>

      <template #glassDimensions="{ item }">
        <div class="u-cursor-pointer">
          <router-link
            :to="{
              name: `vinc-calculating-detail`,
              params: { id: item.id },
            }"
          >
            <span>
              {{ $t("vincCalculating.cabinHeight") }} :
              {{ item.requestCabinHeight }}
            </span>
            <span>
              {{ $t("vincCalculating.frontGlassHeight") }} :
              {{ item.requestFrontGlassHeight }}
            </span>
            <span>
              {{ $t("vincCalculating.sideGlassHeight") }} :
              {{ item.requestSideGlassHeight }}
            </span>
            <span>
              {{ $t("vincCalculating.metalWidth") }} :
              {{ item.requestMetalWidth }}
            </span>
            <span>
              {{ $t("vincCalculating.wallThickness") }} :
              {{ item.requestWallThickness }}
            </span>
            <span>
              {{ $t("vincCalculating.insulationThickness") }} :
              {{ item.requestInsulationThickness }}
            </span>
          </router-link>
        </div>
      </template>
      <template #insulationDimensions="{ item }">
        <span>
          {{ $t("vincCalculating.outdoorTemperature") }} :
          {{ item.requestOutdoorTemperature }}
        </span>
        <span>
          {{ $t("vincCalculating.cabinTemperature") }} :
          {{ item.requestCabinTemperature }}
        </span>
      </template>
      <template #results="{ item }">
        <span>
          {{ $t("vincCalculating.totalGlasses") }} :
          {{ item.totalGlasses }}
        </span>
        <span>
          {{ $t("vincCalculating.totalWalls") }} :
          {{ item.totalWalls }}
        </span>
        <span>
          {{ $t("vincCalculating.cabinTotalThermalLoad") }} :
          {{ item.cabinTotalThermalLoad }}
        </span>
      </template>
      <template #info="{ item }">
        <div
          class="u-margin-bottom-xsmall u-display-flex u-align-items-center u-justify-content-flex-end"
        >
          <div class="u-margin-right-xsmall">
            {{ item.user.fullname }}
          </div>
          <div class="u-color-primary u-margin-right-xsmall">
            <i class="icofont-calendar"></i> {{ date(item.createdDate) }}
          </div>
          <chip
            class="u-margin-0"
            :variant="item.isActive ? 'success' : 'danger'"
          >
            {{ item.isActive ? $tc("common.active") : $tc("common.passive") }}
          </chip>
          <Button
            @click="REMOVE_TO(item)"
            variant="light-danger"
            class="u-margin-0 u-float-right"
          >
            <i class="icofont-trash"></i>
          </Button>
        </div>
      </template>
      <template #updatedDate="{ item }">
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.updatedDate) }}
        </div>
      </template>
    </Table>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "../../Base/Button.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import ExcelExport from "../../Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import mainProjectExportFields from "./export";
import Chip from "../../Base/Chip.vue";
import authorize from "./authorize";
export default {
  components: {
    RemoveModal,
    Table,
    Button,
    ExcelExport,
    Chip,
  },
  mixins: [mainProjectExportFields, authorize],
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "vincCalculating",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      newMainProject: false,
      filter: {},
      sort: {},
      page: 1,
      search: "",
      items: [],
      loading: true,
      count: 0,
      headers: [
        {
          col: 10,
          sm: 2,
          md: 2,
          lg: 2,
          title: "vincCalculating.potDimensions",
          value: "potDimensions",
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "vincCalculating.glassDimensions",
          value: "glassDimensions",
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "vincCalculating.insulationDimensions",
          value: "insulationDimensions",
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "vincCalculating.result",
          value: "results",
        },

        {
          col: 10,
          sm: 12,
          md: 12,
          lg: 12,
          title: "",
          value: "info",
        },
      ],
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
    };
  },
  computed: {
    ...mapGetters({
      getActiveUser: "getActiveUser",
    }),
    pages() {
      return Math.ceil(this.count / 10);
    },
    exportFields() {
      if (this.items.length === 0) return {};
      return this.getExcelFields();
    },
  },
  methods: {
    SET_CHANGE_SORT(headers) {
      const sortedHeaders = headers.filter((item) => item.sort);
      if (sortedHeaders.length === 0) {
        this.sort = {};
        this.getItemsOfPage();
      } else {
        const sort = sortedHeaders[0];
        if (sort.sort.includes("name")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "ALPHABETIC",
          };
        } else if (sort.sort.includes("info")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "DATE",
          };
        }
        this.getItemsOfPage();
      }
    },
    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.CraneHVACC.GetAll({
          query: { page: 1, limit: this.count, search: this.search },
        });
        this.$status.series = response.message;
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [...response.data.items];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.showDetailModal = {
        status: true,
        adminDetailStatus: false,
        item: item,
      };
    },
    showAdminDetail(item) {
      this.showDetailModal = {
        status: false,
        adminDetailStatus: true,
        item: item,
      };
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await Requests.CraneHVACC.Delete({
        params: { id: this.removeModal.item.id },
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeSuccess`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeError`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      this.getItemsOfPage();
    },
    async getItemsOfPage() {
      this.loading = true;
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      const response = await Requests.CraneHVACC.GetAll({
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
          ...this.filter,
          ...this.sort,
          ...this.query,
        },
      });
      this.$status.vincCalculating = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
        this.count = response.data.count;
      }
      this.loading = false;
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
    setFilter(filter) {
      const filterScoped = {
        type: filter.type || "",
        isLocked:
          filter.isLocked == null
            ? ""
            : filter.isLocked
            ? "true"
            : "false" || "",
        userId: filter.user?.id || "",
        batteryId: filter.batteryId?.id || "",
      };
      // remove
      this.filter = filterScoped;
      this.getItemsOfPage(filterScoped);
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
